import { createSlice } from "@reduxjs/toolkit";

export const institution = createSlice({
  name: "institutions",
  initialState: {
    value: {
      status: false,
      data: [] as { id: number; title: string; school_name: string }[],
    },
  },
  reducers: {
    update_institution: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    add_institution: (state, action) => {
      const { id, title, school_name } = action?.payload;
      state.value.data = [...state.value.data, { id, title, school_name }];
    },
    remove_institution: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_institution: (state, action) => {
      const { id, title, school_name } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, {
        id,
        title,
        school_name,
      });
      state.value.data = currentArray;
    },
    clear_institution: (state) => {
      state.value.status = false;
      state.value.data = [
        {
          id: 1,
          title: "",
          school_name: "",
        },
      ];
    },
  },
});

export const {
  update_institution,
  add_institution,
  remove_institution,
  replace_institution,
  clear_institution,
} = institution.actions;

export default institution.reducer;
